import { FunctionComponent, SVGProps } from 'react'

export const IconUnion: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  id,
  ...props
}) => {
  const paint0 = `${id}-paint0`
  const paint1 = `${id}-paint1`

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.4357 9.43566C18.0214 8.84987 18.0214 7.90013 17.4357 7.31434C16.8499 6.72855 15.9001 6.72855 15.3143 7.31434L10.25 12.3787L8.68566 10.8143C8.09987 10.2286 7.15013 10.2286 6.56434 10.8143C5.97855 11.4001 5.97855 12.3499 6.56434 12.9357L9.18934 15.5607C9.77513 16.1464 10.7249 16.1464 11.3107 15.5607L17.4357 9.43566Z"
        fill={`url(#${paint0})`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 0.75C2.62011 0.75 2.01602 1.00022 1.57062 1.44562C1.12522 1.89102 0.875 2.49511 0.875 3.125V9.55516C0.875 19.8206 9.59546 23.1998 11.2527 23.7497C11.7377 23.9144 12.2636 23.9142 12.7486 23.7493C14.4024 23.1983 23.125 19.8161 23.125 9.55297V3.125C23.125 2.49511 22.8748 1.89102 22.4294 1.44562C21.984 1.00022 21.3799 0.75 20.75 0.75H3.25ZM3.875 9.55516V3.75H20.125V9.55297C20.125 17.3631 13.8121 20.186 11.9996 20.8342C10.1897 20.1891 3.875 17.3693 3.875 9.55516Z"
        fill={`url(#${paint1})`}
      />
      <defs>
        <linearGradient
          id={paint0}
          x1="12"
          y1="0.75"
          x2="12"
          y2="23.8731"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0"
            stopColor={props.color ?? 'white'}
            stopOpacity="0.8"
          />
          <stop
            offset="1"
            stopColor={props.color ?? 'white'}
            stopOpacity="0.6"
          />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="12"
          y1="0.75"
          x2="12"
          y2="23.8731"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0"
            stopColor={props.color ?? 'white'}
            stopOpacity="0.8"
          />
          <stop
            offset="1"
            stopColor={props.color ?? 'white'}
            stopOpacity="0.6"
          />
        </linearGradient>
      </defs>
    </svg>
  )
}
